function $c2465f885da9bd1c$export$2e2bcd8739ae039() {
    const toggleButton = document.querySelector('.nav__toggle');
    const navOverlay = document.querySelector('.nav__overlay');
    const body = document.body;
    if (!toggleButton || !navOverlay) {
        console.error('Required elements not found.');
        return;
    }
    const closeMenu = ()=>{
        toggleButton.setAttribute('aria-expanded', 'false');
        navOverlay.setAttribute('aria-hidden', 'true');
        body.classList.remove('no-scroll'); // Enable scrolling
    };
    const openMenu = ()=>{
        toggleButton.setAttribute('aria-expanded', 'true');
        navOverlay.setAttribute('aria-hidden', 'false');
        body.classList.add('no-scroll'); // Disable scrolling
    };
    const toggleMenu = ()=>{
        const isExpanded = toggleButton.getAttribute('aria-expanded') === 'true';
        if (isExpanded) closeMenu();
        else openMenu();
    };
    // Ensure menu closes on desktop viewport
    window.addEventListener('resize', ()=>{
        if (window.innerWidth >= 768) closeMenu();
    });
    // Close menu on outside click
    const handleClickOutside = (event)=>{
        if (!navOverlay.contains(event.target) && !toggleButton.contains(event.target)) closeMenu();
    };
    // Close menu on Escape key
    const handleEscapeKey = (event)=>{
        if (event.key === 'Escape') closeMenu();
    };
    toggleButton.addEventListener('click', toggleMenu);
    document.addEventListener('click', handleClickOutside);
    document.addEventListener('keydown', handleEscapeKey);
}


function $c221a36a605c48cc$export$2e2bcd8739ae039() {
    const header = document.querySelector('.header');
    const topBar = document.querySelector('.top-bar');
    let lastScrollY = window.scrollY;
    let isSticky = false;
    let isHidden = false;
    let scrollDeltaDown = 0;
    function handleScroll() {
        const currentScrollY = window.scrollY;
        const topBarHeight = topBar?.offsetHeight || 43;
        const isDesktop = window.innerWidth >= 768;
        if (currentScrollY <= topBarHeight) {
            header.classList.remove('header--sticky');
            isSticky = false;
            header.classList.remove('header--hidden');
            isHidden = false;
            if (isDesktop) {
                const shiftX = '-50%';
                const shiftY = -currentScrollY;
                header.style.transform = `translate(${shiftX}, ${shiftY}px)`;
            } else header.style.transform = `translateY(${-currentScrollY}px)`;
            scrollDeltaDown = 0;
        } else {
            if (!isSticky) {
                header.classList.add('header--sticky');
                isSticky = true;
                header.style.transform = '';
            }
            if (currentScrollY > lastScrollY) {
                const delta = currentScrollY - lastScrollY;
                scrollDeltaDown += delta;
                if (scrollDeltaDown > 150 && !isHidden) {
                    header.classList.add('header--hidden');
                    isHidden = true;
                }
            } else {
                const delta = lastScrollY - currentScrollY;
                scrollDeltaDown = 0;
                if (delta > 10 && isHidden) {
                    header.classList.remove('header--hidden');
                    isHidden = false;
                }
            }
        }
        lastScrollY = currentScrollY;
    }
    function handleResize() {
        if (window.innerWidth < 768) {
            header.classList.remove('header--sticky', 'header--hidden');
            isSticky = false;
            isHidden = false;
            header.style.transform = '';
            lastScrollY = window.scrollY;
            scrollDeltaDown = 0;
        }
    }
    window.addEventListener('scroll', handleScroll, {
        passive: true
    });
    window.addEventListener('resize', handleResize);
    handleScroll();
    handleResize();
}


function $bd03061fe05e4ccd$export$2e2bcd8739ae039() {
    const playButton = document.querySelector(".hero__play-button");
    const overlay = document.getElementById("videoOverlay");
    const closeButton = document.querySelector(".hero__overlay-close");
    const videoContainer = document.getElementById("videoContainer");
    if (playButton) playButton.addEventListener("click", function() {
        const videoUrl = playButton.getAttribute("data-video");
        if (videoUrl) {
            console.log("Video URL:", videoUrl);
            let videoId = "";
            // Convert "youtu.be/xyz" to "youtube.com/embed/xyz"
            if (videoUrl.includes("youtu.be")) videoId = videoUrl.split("youtu.be/")[1]; // Extract ID
            else if (videoUrl.includes("watch?v=")) videoId = new URL(videoUrl).searchParams.get("v"); // Extract ID
            if (videoId) {
                const youtubeEmbedUrl = `https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0`;
                console.log("Embedding YouTube video:", youtubeEmbedUrl);
                videoContainer.innerHTML = `
            <iframe width="100%" height="100%" src="${youtubeEmbedUrl}"
            frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>
          `;
                overlay.classList.add("show");
            }
        }
    });
    if (closeButton) closeButton.addEventListener("click", function() {
        console.log("Close button clicked!");
        overlay.classList.remove("show");
        videoContainer.innerHTML = ""; // Stop the video
    });
    // Close overlay when clicking outside the video
    overlay.addEventListener("click", function(event) {
        if (event.target === overlay) {
            overlay.classList.remove("show");
            videoContainer.innerHTML = "";
        }
    });
}


function $8b442a22cb289bbc$export$2e2bcd8739ae039() {
    const links = document.querySelectorAll('.intro__nav-link');
    const texts = document.querySelectorAll('.intro__text');
    function showLanguage(lang) {
        texts.forEach((text)=>{
            text.style.display = text.dataset.langContent === lang ? 'block' : 'none';
        });
    }
    links.forEach((link)=>{
        link.addEventListener('click', (e)=>{
            e.preventDefault();
            const lang = link.dataset.lang;
            links.forEach((l)=>l.classList.remove('active'));
            link.classList.add('active');
            showLanguage(lang);
        });
    });
    // Show the first language by default
    if (links.length > 0) {
        links[0].classList.add('active');
        showLanguage(links[0].dataset.lang);
    }
}


function $ed508d573553a4f2$export$2e2bcd8739ae039() {
    const navButtons = document.querySelectorAll('.feature-highlights__nav-button');
    const mediaItems = document.querySelectorAll('.feature-highlights__media-item');
    if (navButtons.length === 0 || mediaItems.length === 0) {
        console.warn("Feature Highlights: No nav buttons or media items found.");
        return;
    }
    function showMedia(index) {
        mediaItems.forEach((item)=>{
            if (item.dataset.index === index) item.classList.add("visible");
            else item.classList.remove("visible");
        });
    }
    navButtons.forEach((button)=>{
        button.addEventListener("click", (e)=>{
            e.preventDefault();
            const index = button.dataset.index;
            // Deactivate all nav buttons, activate the clicked one
            navButtons.forEach((btn)=>btn.classList.remove("active"));
            button.classList.add("active");
            // Show the corresponding media item
            showMedia(index);
        });
    });
    // Activate the first button by default
    navButtons[0].classList.add("active");
    showMedia(navButtons[0].dataset.index);
}


document.addEventListener("DOMContentLoaded", ()=>{
    (0, $c2465f885da9bd1c$export$2e2bcd8739ae039)();
    (0, $c221a36a605c48cc$export$2e2bcd8739ae039)();
    (0, $bd03061fe05e4ccd$export$2e2bcd8739ae039)();
    (0, $8b442a22cb289bbc$export$2e2bcd8739ae039)();
    (0, $ed508d573553a4f2$export$2e2bcd8739ae039)();
});


//# sourceMappingURL=main.js.map
